import FormContainer from "@/components/signUp/form/FormContainer.vue";

export const global = {
  add: "新增",
  all: "全部",
  allVehicle: "全部设备",
  apply: "应用",
  applyToAll: "全部更新为",
  cancel: "取消",
  colon: "：",
  comma: "，",
  confirm: "确认",
  confirmDeletion: "确认删除",
  calenderDayOfWeek1: "一",
  calenderDayOfWeek2: "二",
  calenderDayOfWeek3: "三",
  calenderDayOfWeek4: "四",
  calenderDayOfWeek5: "五",
  calenderDayOfWeek6: "六",
  calenderDayOfWeek7: "日",
  calenderYearMonth: "{year}{month}",
  calenderYear: "{year}年",
  calenderMonth1: "1月",
  calenderMonth10: "10月",
  calenderMonth11: "11月",
  calenderMonth12: "12月",
  calenderMonth2: "2月",
  calenderMonth3: "3月",
  calenderMonth4: "4月",
  calenderMonth5: "5月",
  calenderMonth6: "6月",
  calenderMonth7: "7月",
  calenderMonth8: "8月",
  calenderMonth9: "9月",
  delete: "删除",
  deletedSuccessfully: "删除成功",
  discard: "取消",
  edit: "编辑",
  empty: "空",
  failedToDelete: "删除失败",
  failedToSave: "保存失败",
  Friday: "星期五",
  in: "英寸",
  kmh: "千米/时",
  loading: "加载中……",
  maximumCharactersCanUsed: "最长支持{0}个字符",
  minimumCharactersLong: "最少输入{0}个字符",
  mm: "毫米",
  Monday: "星期一",
  mph: "英里/时",
  mustContainBetweenCharacters: "支持{0}到{1}个字符",
  NA: "未知",
  no: "否",
  noData: "没有数据",
  noMatchingData: "没有匹配的数据",
  none: "无",
  ok: "确定",
  phoneNumberTips: "仅支持0-9",
  pleaseSelect: "请选择",
  retry: "重试",
  Saturday: "星期六",
  save: "保存",
  saveAs: "另存为",
  savedSuccessfully: "保存成功",
  secs: "秒",
  subtitle: "显示字段",
  Sunday: "星期日",
  Thursday: "星期四",
  to: "到",
  Tuesday: "星期二",
  unknownDriver: "操作员",
  view: "查看",
  warning: "警告",
  Wednesday: "星期三",
  yes: "是",
  m: "米",
  ft: "英尺",
  onlyLengthCharactersCanBeUsed: "仅支持{0}个字符",
  cm: "厘米",
  mapLoadError: "地图加载失败",
  startMonth: "开始月份",
  endMonth: "结束月份",
  startDate: "开始日期",
  endDate: "结束日期",
  startYear: "开始年份",
  endYear: "结束年份",
  back: "返回",
  discardChange: "放弃更改",
  relate: "关联",
  front: "前",
  rear: "后",
  left: "左",
  right: "右",
  frontRight: "右前",
  rearRight: "右后",
  drive: "驾驶",
  inputError: "保存失败, 请检查输入项",
  km: "千米",
};
